export default __webpack_public_path__ + "static/media/Back-Path.d445f3b1.svg";